import { request } from '@wix/da-shared-react/pkg/xhr';
import { call, put } from 'redux-saga/effects';
import { deleteItems } from '@wix/da-shared-react/pkg/Stream/base/actions';
import { API_BASE_PATH } from '../../constants';

function* leaveGroup(data) {
  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/groups/leave`,
    data,
  });
}

export default function* leaveGroupSaga(action) {
  const { payload } = action;
  const response = yield call(leaveGroup, { groupid: payload.groupId });

  if (response && response.success) {
    yield put(
      deleteItems({
        streamId: payload.streamId,
        items: [payload.groupId],
      })
    );
    return;
  }
}
